module.exports = "<h3>Hint</h3>\n<div class=\"text-muted\">消息通知类的alert可以用这个</div>\n<section>\n  <div>\n      <pre>\n        <code class=\"language-html\" ng-bind-html=\"vm.exampleHtml\"></code>\n      </pre>\n  </div>\n</section>\n<h3>示例</h3>\n<section>\n  <div class=\"row\">\n    <div class=\"col-xs-6\">\n      <input type=\"text\" class=\"form-control\" ng-model=\"hintContent\" />\n      <button class=\"btn btn-default\" ng-click=\"myHint()\">Hint</button>\n    </div>\n  </div>\n</section>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./examples/service/hint/template.html
 ** module id = 245
 ** module chunks = 0
 **/